import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Select as AntSelect, SelectProps as SelectProps } from '@vertem-core/vertice-ds';

const SelectWrapper = styled.div`
  position: relative;
`;

const paddingResponsive = '40px';

const StyledLabel = styled.label<{ isFocused: boolean; hasValue: boolean }>`
  position: absolute;
  top: ${(props) => (props.isFocused || props.hasValue ? '8px' : 'calc(50%)')};
  left: ${paddingResponsive};
  transform: translateY(${(props) => (props.isFocused || props.hasValue ? '0' : '-50%')});
  font-size: ${(props) => (props.isFocused || props.hasValue ? '12px' : '16px')};
  color: ${(props) => (props.isFocused ? 'var(--colorTextInput)' : 'var(--colorTextPlaceholder)')};
  transition: all 0.3s ease;
  pointer-events: none;
  z-index: 999;
`;

const StyledSelect = styled(AntSelect)`
  text-align: left;

  &.ant-select-single.ant-select-lg {
    height: 50px !important;
  }
  &.ant-select-selector {
    height: 50px !important;
    padding: 20px ${paddingResponsive} 8px ${paddingResponsive} !important;
    display: flex;
    align-items: center;
  }
  .ant-select-selector {
    height: 50px !important;
    padding: 20px ${paddingResponsive} 8px ${paddingResponsive} !important;
    display: flex;
    align-items: center;
  }
`;

const Select: React.FC<SelectProps> & { Option: typeof AntSelect.Option } = (props: any) => {
  const [isFocused, setIsFocused] = useState(false);

  const [hasValue, setHasValue] = useState(!!props.value);

  useEffect(() => {
    setHasValue(!!props.value);
  }, [props.value]);

  return (
    <SelectWrapper>
      <StyledLabel isFocused={isFocused} hasValue={hasValue}>
        {props.placeholder}
      </StyledLabel>
      <StyledSelect
        {...props}
        placeholder={undefined}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onChange={(value: any) => {
          setHasValue(!!value);

          if (props.onChange) {
            props.onChange(value);
          }
        }}
        onDropdownVisibleChange={(open: any) => {
          if (!open) setIsFocused(false);
        }}
      />
    </SelectWrapper>
  );
};

// Assigning the static property Option to the custom Select component
Select.Option = AntSelect.Option;

export default Select;
